<template>
  <div class="anal-data-master-container" v-if="drilldownData">
    <div class="frequencia-anal-container">
      <div class="freq-header">
        <span v-text="$t('groupings_groups')"></span>
        <span v-text="$t('minimum_month')"></span>
        <span v-text="$t('maximum_month')"></span>
        <span v-text="$t('maximum_week')"></span>
        <span v-text="$t('total_month')"></span>
        <span v-text="$t('PU_contribution')"></span>
      </div>
      <div class="freq-data-cont">
        <div class="agrup-cont" v-for="agp in drilldownData">
          <div class="agrup-data">
            <div class="name">
              <span v-text="agp.nm_agrupamento_grupo" @click="changeIncVisib(agp)"></span>
              
            <!-- TODO - componente para mostrar os grupos por colunas-->
            <!--  <DistributionOfIncidences :visible="ActiveDist" :incidences="agp.distribution_of_incidences" :agp="agp" @changeVisOfDistribuition="changeIncVisib()"></DistributionOfIncidences> -->
            </div>
            <div class="freq-container">
              <span class="frequencias" v-text="agp.freq.qt_min_mes || '--'"></span>
              <span class="frequencias" v-text="agp.freq.qt_max_mes || '--'"></span>
              <span class="frequencias" v-text="agp.freq.qt_max_sem || '--'"></span>
              <span class="frequencias" v-text="agp.qt_utilizado || '--'"></span>
              <span class="frequencias" v-text="'R$ ' + parseFloat(agp.vlr_pu).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
            </div>
          </div>

          <div class="group-data" v-for="(gp,key) in agp.grupos">
            <div class="name" :class="{'isUnderOrOver': gp.freqError}">
              <span :key="key" v-text="gp.nm_grupo" @click="changeUtVisible(gp)"></span>
              <div
                class="overlay"
                :class="{'visible': ActiveUtil}"
                @click="changeUtVisible(gp)"
              ></div>              
              <AnalPratUtil :visible="ActiveUtil === gp.id_grupo" :grupo="gp.utilizacao"></AnalPratUtil>
              <img
                class="lackOfCost"
                v-if="gp.id_sem_custo"
                :src="moneyIcon"
                :title="$t('dishes_have_no_cost_or_the_cost_is_out_of_date')"
              />
            </div>
            <div class="freq-container" :class="{'isUnderOrOver': gp.freqError}">
              <span class="frequencias" v-text="gp.freq.qt_min_mes || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="gp.freq.qt_max_mes || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="gp.freq.qt_max_sem || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="gp.qt_utilizado || '--'" @click="changePratoVisib(gp)"></span>
              <span class="frequencias" v-text="'R$ ' + parseFloat(gp.vlr_pu).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')" @click="changePratoVisib(gp)"></span>
              <div
                class="overlay"
                :class="{'visible': ActivePratos}"
                @click="changePratoVisib(gp)"
              ></div>
              <AnalResultPrato
                :visible="ActivePratos === gp.id_grupo"
                :pratoList="gp.pratos"
              ></AnalResultPrato>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AnalResultPrato from "@/components/src/AnalResultPratoComponent";
import AnalPratUtil from "@/components/src/AnalPratUtilComponent";
import DistributionOfIncidences from "@/components/src/distributionOfIncidencesComponent";

export default {
  name: "AnalDataContainer",
  props: {
    drilldownData: {
      type: Array,
      required: true
    }
  },
  components: {
    AnalResultPrato,
    AnalPratUtil,
    DistributionOfIncidences
  },
  data() {
    return {
      moneyIcon: require("../../../static/sifrao.png"),
      ActivePratos: null,
      ActiveUtil: null,
      ActiveDist: false,
    };
  },
  methods: {
    changeIncVisib: function(gp) {
      this.ActiveDist = this.ActiveDist ? null : gp.id_grupo;
    },
    changePratoVisib: function(gp) {
      this.ActivePratos = this.ActivePratos ? null : gp.id_grupo;
    },
    changeUtVisible: function(gp) {
      this.ActiveUtil = this.ActiveUtil ? null : gp.id_grupo;
    },
  }
};
</script>
<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.frequencia-anal-container {
  margin-top: 30px;
  padding: 0;
  .pratos-container, .inc-container {
    position: fixed;
    display: none;
    &.visible {
      position: fixed;
      z-index: 5;
      background: #fff;
      width: 700px;
      overflow: auto;
      z-index: 12;
      .full;
      margin: auto;
      display: inline-table;
    }
  }
  .inc-container.visible {
    //pointer-events: none;
    max-height: calc(100vh - 15%);
    background: transparent;
    width: calc(100vw - 15%);
    overflow: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: auto;
    display: inline-flex;
    cursor: auto;
  }
  .overlay {
    position: fixed;
    .full;
    //background: rgba(0, 0, 0, 0.3);
    display: none;
    &.visible {
      display: block;
      z-index: 10;
    }
  }
  .overlay,
  .pratos-container {
    cursor: default;
  }
  .freq-header {
    display: grid;
    @size: calc((100% - 25%) / 5);
    grid-template-columns: 25% @size @size @size @size @size;
    background: @azul;
    color: #fff;
    border-radius: 5px;
    span {
      text-align: center;
      padding: 5px 0;
      text-transform: uppercase;
    }
  }
  .freq-data-cont {
    position: relative;
    display: block;
    max-height: calc(100vh - 100px);
    overflow: auto;
    padding-bottom: 15px;
    font-size: 13px;
    span {
      padding: 5px 0;
    }
  }
  .agrup-cont {
    margin: 30px 0px 0;
    &:first-of-type {
      margin-top: 5px;
    }
    .sombra;
    .agrup-data {
      background: #c4c4c4;
      .name {
        position: relative;
        span:not(.frequencias) {
          font-weight: bold;
        }
      }
    }
    .agrup-data,
    .group-data {
      position: relative;
      display: grid;
      grid-template-columns: 25% 75%;
      cursor: pointer;
      span:not(.frequencias) {
        padding-left: 5px;
        display: block;
      }
      .name.isUnderOrOver {
        > span {
          color: red;
        }
      }
      .freq-container {
        position: relative;
        display: grid;
        grid-template-columns: 100%/5 100%/5 100%/5 100%/5 100%/5;
        .frequencias {
          text-align: center;
        }
        &.isUnderOrOver {
          > span:not(:last-of-type) {
            color: red;
          }
        }
      }
      &:before {
        content: "";
        position: absolute;
        pointer-events: none;
      }
      &:hover {
        &:before {
          content: "";
          .full;
          border: solid 1px red;
        }
      }
      .lackOfCost {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 5px;
        max-width: 15px;
        margin: auto;
        z-index: 3;
      }
    }
    .group-data {
      &:nth-of-type(2n) {
        background: rgba(196, 196, 196, 0.2);
      }
    }
  }
}
.anal-data-container {
  margin: 10px 35px 0 5px;
  position: relative;
  display: grid;
  @larg: 100% /7;
  grid-template-columns: @larg @larg @larg @larg @larg @larg @larg;
  .anal-data {
    position: relative;
    display: block;
    &:before {
      content: "";
      position: absolute;
      .full;
      border: solid 1px white;
    }
    span {
      text-align: center;
      display: block;
      &:first-of-type {
        background: @azul;
        color: white;
      }
    }
  }
}

@media screen and (max-width: 1271px) {
  .anal-data-container {
    grid-template-columns: 50% 50%;
  }
}
</style>